import React from "react";

import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { useRecoilState } from "recoil";
import { tourAtom, skipTourAtom } from "./tourAtom";

import {
  IntroTourStep,
  FocusAreaLayerTourStep,
  FocusAreaTourStep,
  FocusAreaDetailsTourStep,
  RadiusSliderTourStep,
  TabsTourStep,
  LayersTourStep,
  DownloadMapViewTourStep,
  TourStepFinal,
} from "./tourText";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";

const getTourSteps = (isMobile) => {
  const steps = [
    newStep(".map-test-classname", <IntroTourStep />, "bottom"),
    newStep(".focus-area-layer-dropdown", <FocusAreaLayerTourStep />),
    newStep(".map-test-classname", <FocusAreaTourStep />, "right", false),
    newStep(".focus-area-details", <FocusAreaDetailsTourStep />),
    newStep(".radius-slider", <RadiusSliderTourStep />),
    newStep(".layers-tabs", <TabsTourStep />),
    newStep(".layer-check-boxes", <LayersTourStep />),
    !isMobile && newStep("#download-map-view-button", <DownloadMapViewTourStep />),
    newStep(".map-test-classname", <TourStepFinal />),
  ]

  return steps.filter((step) => !!step);
}

const newStep = (target, content, placement, disableOverlayClose=true) => {
  return {
    target: target,
    content: content,
    placement,
    disableOverlayClose,
    disableBeacon: true,
    floaterProps: {
      disableAnimation: true,
    },
  }
}

const Tour = () => {
  const [tourState, setTourState] = useRecoilState(tourAtom);
  const [skipTour, setSkipTour] = useRecoilState(skipTourAtom);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      setTourState((currentTourState) => ({
        ...currentTourState,
        run: action !== ACTIONS.CLOSE,
        stepIndex: index + (action === ACTIONS.PREV ? -1 : 1),
      }));
      // setTourRun(action !== ACTIONS.CLOSE);
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      setTourState((currentTourState) => ({ ...currentTourState, run: false }));
      setSkipTour(true);
    }
  };

  if (skipTour) {
    return null
  }

  return (
    <Joyride
      {...tourState}
      showSkipButton={true}
      callback={handleJoyrideCallback}
      locale={{
        back: "Back",
        close: "Close",
        last: "Finish",
        next: "Next",
        skip: "Skip Tour",
      }}
      steps={getTourSteps(isMobile)}
      styles={{
        options: {
          primaryColor: "#00AEEF",
          zIndex: 1000000,
        },
        buttonNext: {
          borderRadius: 0,
        },
      }} />
  )
};

export default Tour;
